import type { ReactNode } from "react";

import { usePermission } from "./use-permission";

/**
 * Conditionally render children based on a permission check.
 * Renders `fallback` (default: nothing) when the permission is absent.
 */
export function PermissionGate({
  permission,
  children,
  fallback,
}: {
  permission: string;
  children: ReactNode;
  fallback?: ReactNode;
}): ReactNode {
  const hasPermission = usePermission(permission);
  return hasPermission ? children : (fallback ?? null);
}
